import Banner from "../../elements/common/banner";
import { bannerData } from "../../../globals/banner";
import MesIntro from "./mesintro";
import MesCategoriePrequel from "./mescategorieprequel";
import MesDeclaration from "./mesdeclaration";

const MesComm = () => {

    return (
        <>
            <Banner _data={bannerData.mes} />
            <MesIntro></MesIntro>
            <div className="panesupervisorcomm bggrey section-full p-t110 mobile-page-padding">
                <MesCategoriePrequel></MesCategoriePrequel>
            </div>
            <div className="panesupervisorcomm bgwhite section-full p-t110 mobile-page-padding">
                <MesDeclaration></MesDeclaration>
            </div>
        </>
    );

};

export default MesComm;